<div class="hcenter">
    <div class="has-error okta-error token-expired" *ngIf="token.expired">
        <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
        <p class="show-message">
            <span id="token-expired">{{token.errorMessage}}</span>
        </p>
    </div>
</div>